import { cn } from '@/lib/utils';
import { FunctionComponent, useState } from 'react';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { Button } from '../form/Button';
import { ButtonVariant } from '../form/buttonHelper';
import { SortDirection } from '../table/sortHelper';

interface SortButtonsProps {
  onSortCallback: (direction: SortDirection) => void;
  sortDirection?: SortDirection;
  isActiveCallback?: () => boolean;
}

const SortButtons: FunctionComponent<SortButtonsProps> = ({ onSortCallback, sortDirection, isActiveCallback }) => {
  const [activeDirection, setActiveDirection] = useState(sortDirection);

  const getSortButtonStyles = (directionToStyle: SortDirection) => {
    return cn(
      'p-0.5 rounded-full',
      directionToStyle === activeDirection && (isActiveCallback ? isActiveCallback() : true)
        ? '!bg-[#2095A7] !text-white'
        : ''
    );
  };

  const onClick = (direction: SortDirection) => {
    setActiveDirection(direction);
    onSortCallback && onSortCallback(direction);
  };

  return (
    <div className="flex">
      <Button
        className={getSortButtonStyles(SortDirection.ASC)}
        variant={ButtonVariant.Ghost}
        onClick={() => onClick(SortDirection.ASC)}
      >
        <FiArrowUp />
      </Button>
      <Button
        className={getSortButtonStyles(SortDirection.DESC)}
        variant={ButtonVariant.Ghost}
        onClick={() => onClick(SortDirection.DESC)}
      >
        <FiArrowDown />
      </Button>
    </div>
  );
};

export default SortButtons;
